const USER_PERMISSION_KEY = "__user__";

function rolePermission(rule, roleType) {
  return (rule?.roles || []).find((role) => String(role.key) === String(roleType))?.permission;
}

function resolveUserPermission(rule, user = {}) {
  if (user.roleType === 1 || user.roleType === 2) return true;
  const override = (user.permissionOverrides || []).find(({ ruleId }) => String(ruleId) === String(rule?._id));
  return override ? override.permission : rolePermission(rule, user.roleType);
}

function buildUserPermissionRules(rules = [], user = {}) {
  return rules.map((rule) => ({
    ...rule,
    roles: [{ key: USER_PERMISSION_KEY, permission: resolveUserPermission(rule, user) }],
  }));
}

function buildPermissionOverrides(sourceRules = [], editedRules = [], roleType) {
  const sourceById = new Map(sourceRules.map((rule) => [String(rule._id), rule]));
  return editedRules.reduce((overrides, rule) => {
    const source = sourceById.get(String(rule._id));
    const permission = rule.roles?.find((role) => role.key === USER_PERMISSION_KEY)?.permission;
    if (source && permission !== rolePermission(source, roleType)) {
      overrides.push({ ruleId: String(rule._id), permission });
    }
    return overrides;
  }, []);
}

function memberPermissionLabel(member = {}) {
  const email = String(member.userEmail || "").trim();
  const name = String(member.Employee_Name || member.employee_name || "").trim();
  return name && name !== email ? `${name} — ${email}` : email || name;
}

function mergePermissionMember(member = {}, user = {}) {
  const profile = user.ghostUser ? {} : user;
  return {
    ...member,
    ...profile,
    userId: member.userId || user._id,
    userEmail: member.userEmail || user.Employee_Email || "",
  };
}

module.exports = {
  USER_PERMISSION_KEY,
  buildPermissionOverrides,
  buildUserPermissionRules,
  memberPermissionLabel,
  mergePermissionMember,
  resolveUserPermission,
  rolePermission,
};
